import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TemplateRef,
} from '@angular/core';
import { TooltipPosition } from './tooltip.positions';

const CARET_CLASSES: Record<TooltipPosition, string> = {
  top: 'left-1/2 -translate-x-1/2 -bottom-1 border-x-4 border-t-4 border-x-transparent border-t-midnight',
  bottom:
    'left-1/2 -translate-x-1/2 -top-1 border-x-4 border-b-4 border-x-transparent border-b-midnight',
  left: 'top-1/2 -translate-y-1/2 -right-1 border-y-4 border-l-4 border-y-transparent border-l-midnight',
  right:
    'top-1/2 -translate-y-1/2 -left-1 border-y-4 border-r-4 border-y-transparent border-r-midnight',
};

@Component({
  selector: 'interface-tooltip-panel',
  imports: [NgTemplateOutlet],
  templateUrl: './tooltip-panel.component.html',
  styleUrl: './tooltip-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'relative block py-1.5 px-2.5 rounded-md bg-midnight text-white text-xs leading-5 font-medium pointer-events-none shadow-md whitespace-pre-line',
    'animate.enter': 'tooltip-fade-enter',
    'animate.leave': 'opacity-0 transition-opacity duration-150 ease-in',
    role: 'tooltip',
    '[style.max-width.px]': 'maxWidth()',
  },
})
export class TooltipPanelComponent {
  readonly content = input<string | null>(null);
  readonly contentTemplate = input<TemplateRef<unknown> | null>(null);
  readonly position = input<TooltipPosition>('top');
  readonly maxWidth = input(256);

  readonly caretClasses = computed(
    () => `absolute w-0 h-0 border-solid ${CARET_CLASSES[this.position()]}`,
  );
}
